<template>
  <div
    class="asc-bar-chart-wrapper--container"
    data-automation-id="wrapper_bar_chart"
  >
    <asc-bar-chart
      :title="title"
      :values="values"
      :series-name="seriesName"
      :category-name="categoryName"
      :loading="loading"
    ></asc-bar-chart>
  </div>
</template>

<script>
import AscBarChart from '@/components/molecules/AscBarChart'

export default {
  name: 'AscBarChartWrapper',

  components: {
    AscBarChart,
  },

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    seriesName: {
      type: String,
      default: '',
    },
    categoryName: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
